import { Tooltip } from '@chakra-ui/react';
import { FC, SyntheticEvent } from 'react';
import { IconButton, IconButtonProps } from './Button';

export interface ActionIconButtonProps
    extends Omit<IconButtonProps, 'aria-label' | 'onClick'> {
    label: string;
    onClick: (e: SyntheticEvent<HTMLButtonElement>) => void;
}

const ActionIconButton: FC<ActionIconButtonProps> = ({
    label,
    onClick,
    variant = 'ghost',
    ...rest
}) => {
    return (
        <Tooltip label={label} aria-label={label}>
            <IconButton
                {...rest}
                variant={variant}
                onClick={onClick}
                aria-label={label}
            />
        </Tooltip>
    );
};

export default ActionIconButton;
